/**
 * TextField - Reusable text/textarea input component
 * Uses Tailwind utilities for layout, DaisyUI for input styling
 */
/// <reference lib="dom" />

interface TextFieldProps {
  label: string;
  value?: string;
  name?: string;
  type?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  multiline?: boolean;
  rows?: number;
  disabled?: boolean;
  error?: string;
  hint?: string;
  required?: boolean;
}

export const TextField = ({
  label,
  value,
  name,
  type = "text",
  onChange,
  placeholder,
  multiline = false,
  rows = 3,
  disabled = false,
  error,
  hint,
  required = false,
}: TextFieldProps) => {
  const handleChange = (e: Event) => {
    onChange?.((e.target as HTMLInputElement | HTMLTextAreaElement).value);
  };

  return (
    <div class="flex flex-col gap-1">
      <label class="text-sm font-medium">{label}</label>
      {multiline
        ? (
          <textarea
            name={name}
            class={`textarea textarea-bordered w-full ${
              error ? "textarea-error" : ""
            }`}
            value={value}
            onInput={handleChange}
            placeholder={placeholder}
            rows={rows}
            disabled={disabled}
            required={required}
          />
        )
        : (
          <input
            type={type}
            name={name}
            class={`input input-bordered w-full ${error ? "input-error" : ""}`}
            value={value}
            onInput={handleChange}
            placeholder={placeholder}
            disabled={disabled}
            required={required}
          />
        )}
      {hint && !error && <span class="text-xs opacity-60">{hint}</span>}
      {error && <span class="text-xs text-error">{error}</span>}
    </div>
  );
};
